






import { Component, Vue, Prop } from "vue-property-decorator";
import ListShopsItem from "@/components/pages/shops/ListShopsItem.vue";
import { IMerchantInShops } from "@/store/interfaces/shops.ts";

@Component({
  name: "ListShops",
  components: {
    ListShopsItem
  }
})
export default class ListShops extends Vue {
  @Prop({ default: null })
  merchants: IMerchantInShops[];

  elepsize: boolean = false;

  maxHeightElement: number = 252;

  beforeUpdate() {
    this.maxHeightElement = Math.ceil(this.merchants.length / 4) * 28;
  }
}
